import { render, staticRenderFns } from "./AuctionsPg.vue?vue&type=template&id=6735babd&scoped=true&"
import script from "./AuctionsPg.vue?vue&type=script&lang=js&"
export * from "./AuctionsPg.vue?vue&type=script&lang=js&"
import style0 from "./AuctionsPg.vue?vue&type=style&index=0&id=6735babd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6735babd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
